var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.022 0 c -4.965 0.004 -8.983 4.033 -8.98 8.998 c -0.004 4.965 4.018 8.994 8.983 8.998 h 8.983 V 9.002 C 42.013 4.037 37.991 0.007 33.022 0 C 33.026 0 33.026 0 33.022 0 M 33.022 24 H 9.073 c -4.965 0.004 -8.987 4.033 -8.983 8.998 C 0.083 37.963 4.105 41.993 9.07 42 h 23.952 c 4.965 -0.004 8.987 -4.033 8.983 -8.998 C 42.009 28.033 37.987 24.004 33.022 24 L 33.022 24 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(54,197,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.91 32.998 c 0.004 -4.965 -4.018 -8.994 -8.983 -8.998 c -4.965 0.004 -8.987 4.033 -8.983 8.998 V 42 h 8.983 C 85.892 41.996 89.914 37.967 89.91 32.998 z M 65.958 32.998 v -24 c 0.004 -4.961 -4.015 -8.991 -8.98 -8.998 c -4.965 0.004 -8.987 4.033 -8.983 8.998 v 24 c -0.007 4.965 4.015 8.994 8.98 9.002 C 61.939 41.996 65.961 37.967 65.958 32.998 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(46,182,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.974 90 c 4.965 -0.004 8.987 -4.033 8.983 -8.998 c 0.004 -4.965 -4.018 -8.994 -8.983 -8.998 h -8.983 v 8.998 C 47.987 85.963 52.009 89.993 56.974 90 z M 56.974 65.996 h 23.952 c 4.965 -0.004 8.987 -4.033 8.983 -8.998 c 0.007 -4.965 -4.015 -8.994 -8.98 -9.002 H 56.978 c -4.965 0.004 -8.987 4.033 -8.983 8.998 C 47.991 61.963 52.009 65.993 56.974 65.996 L 56.974 65.996 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,178,46)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.09 56.998 c -0.004 4.965 4.018 8.994 8.983 8.998 c 4.965 -0.004 8.987 -4.033 8.983 -8.998 V 48 H 9.073 C 4.108 48.004 0.086 52.033 0.09 56.998 z M 24.042 56.998 v 24 c -0.007 4.965 4.015 8.994 8.98 9.002 c 4.965 -0.004 8.987 -4.033 8.983 -8.998 V 57.006 c 0.007 -4.965 -4.015 -8.994 -8.98 -9.002 C 28.057 48.004 24.039 52.033 24.042 56.998 C 24.042 56.998 24.042 57.002 24.042 56.998",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(224,30,90)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.52f2d00f7bd3ccb0e317c8ea529e4e1c.svg";
export { ForwardRef as ReactComponent };